import React, { useCallback } from 'react';
import { route } from '../../../../../services/utils';
import {
  LIVESTOCK_ANIMALS_AND_EVENTS_INDEX,
  LIVESTOCK_ANIMALS_SEPARATION_VIEW,
} from '../../../../../router/routes';
import { schema } from './separationSchema';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Form from '../../../../../components/form';
import useFormBody from './use-form-body';
import { useEditFooter } from '../use-edit-footer';
import useFormTop from './use-form-top';
import { useSeparationState } from './use-separation-state';
import { useSeparationUpdate } from './use-separation-update';
import FormTable from './form-table';
import AnimalsAndEventsTabsKeys from '../../enums/animals-and-events-tab-keys';
import animalEventFormCss from '../animal-events-form.module.css';
import { useQuery } from '../../../../../hooks/use-query';

export default function EditSeparation() {
  const { farmId } = useParams<{
    farmId: string;
  }>();
  const [queries] = useQuery();

  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback(
    (key: string, params?: { [key: string]: string | number }) =>
      t(transKeyPrefix.concat(key), params),
    [t]
  );

  const footer = useEditFooter(
    `${LIVESTOCK_ANIMALS_SEPARATION_VIEW}${
      queries.to ? '?to='.concat(queries.to) : ''
    }`
  );
  const {
    separationState,
    animals,
    removeRow,
    addRow,
    eventType,
    setEventType,
  } = useSeparationState();
  const body = useFormBody(animals);
  const top = useFormTop({ addRow, setEventType, animals, showFilters: true });
  const submit = useSeparationUpdate(animals);

  return (
    <Form
      backTo={route(LIVESTOCK_ANIMALS_AND_EVENTS_INDEX, {
        tab:
          queries.to === 'events'
            ? AnimalsAndEventsTabsKeys.events
            : AnimalsAndEventsTabsKeys.animals,
        farmId,
      })}
      schema={schema}
      title={tp('animals.types.separation')}
      body={body}
      top={top}
      footer={footer}
      mode={'edit'}
      submit={submit}
      values={separationState}
      className={animalEventFormCss['animal_event_form']}
    >
      <FormTable
        removeRow={removeRow}
        eventType={eventType}
        animals={animals}
        showRemove={true}
      />
    </Form>
  );
}
